<template>
  <Modal
    v-model="isOpen"
    closeCross
    persistent
    drawer
    class="KeepPlanModal"
    :title="t('ui.subscription.cancelPlan.keepPlan.confirmation.title')"
  >
    <div class="KeepPlanModal-content">
      <p class="KeepPlanModal-description">
        {{ t('ui.subscription.cancelPlan.keepPlan.confirmation.description') }}
      </p>

    </div>

    <template #actionPrimary>
      <ActionButton
        variant="primary"
        :size
        :loading
        @click="confirmKeepPlan"
      >
        {{ t('ui.subscription.cancelPlan.keepPlan.confirmation.action') }}
      </ActionButton>
    </template>
  </Modal>
</template>

<script setup lang="ts">
defineProps<{
  loading?: boolean;
}>();

const emit = defineEmits<{
  confirmed: []
}>();

const { isMobile } = useResponsive();
const size = computed(() => (isMobile.value ? 'sm' : 'md'));

const { t } = useI18n();

const isOpen = defineModel<boolean>({ default: false });

function confirmKeepPlan() {
  emit('confirmed');
}
</script>